import { Country } from "./countries.service";
import { ConfigService } from "./config.service";
import { HttpServiceService } from "./http-service.service";
import { Injectable } from "@angular/core";
import { StorageMap } from "@ngx-pwa/local-storage";
import { flatMapSeries } from "src/assets/scripts/vidyoclient";
export interface W9Data {
  otherExplanation: string;
  id: number;
  fatcaId: number;
  userId: string;
  name: string;
  entityName: string;
  taxClassification: string;
  isLimited: boolean;
  addressInUsLine1: string;
  addressInUsLine2: string;
  state: string;
  city: string;
  postCode: string;
  accountNumber: string;
  payeeCode: string;
  fatcaReportingCode: string;
  isAnyOtherRequester: boolean;
  requesterName: string;
  requesterAddressLine1: string;
  requesterAddressLine2: string;
  requesterState: string;
  requesterCity: string;
  requesterPostCode: string;
  typeOfTaxPayer: string;
  taxNumber: string;
  isReportedByIRS: string;
  isActive: boolean;
  createdBy: string;
  createdOn: Date;
}
export interface CRSData {
  id: number;
  fatcaId: number;
  userId: string;
  taxCountry: string;
  tinAvailable: string;
  tinNumber: string;
  reason: string;
  reasonExplantion: string;
  isActive: boolean;
  createdBy: string;
  createdOn: Date;
}
export interface AddData1 {
  expectedMonthlyTrnOver: string;
  monthlyIncome: string;
  otherNationality: string;
  CountryList: string;
}
export interface FatcaAnswer {
  consent: boolean;
  crsconfirm: boolean;
  fatcaconsent: boolean;
  question1: string;
  question2: string;
  question3: string;
  question4: string;
  question5: string;
  residentPakistani: boolean;
  termsandcondition: boolean;
}
export interface AddData {
  cardTypeReason: string;
  id: string;
  nameOfRemitter: string;
  otherNationality: string;
  relationshipwithRemitter: string;
  applicationId: string;
  customerId: string;
  placeOfBirth: string;
  countryOfBirth: string;
  fatherName: string;
  isFatherName: boolean;
  motherName: string;
  cardType: string;
  atm: boolean;
  sms: boolean;
  smSPlan: string;
  eStatement: boolean;
  statementFrequency?: any;
  email: string;
  chequeBook: boolean;
  chequeBookLeave: number;
  zakatDeduction: boolean;
  occupation: string;
  residenceHouseNo: string;
  residenceBuilding: string;
  residenceStreet: string;
  residenceRoad: string;
  residenceStateId: number;
  residenceCityId: number;
  postCodeResidence?: any;
  residenceContact?: any;
  countryOfResidence: string;
  mailingHouseNo: string;
  mailingBuilding: string;
  mailingStreet: string;
  mailingRoad: string;
  mailingStateId: number;
  mailingCityId: number;
  postCodeOfMailAdd?: any;
  mailingContact?: any;
  countryOfMailAdd: string;
  maritalStatus: string;
  minorFatherName: string,
  minorMotherName: string,
  minorCitybirth: string,
  minorDualNationality: boolean,
  minorDualNationalityCountry: string,
  minorTaxResidency: boolean,
  minorTaxResidencyCountry: string,
  minorFSupporterName: string,
  minorFSupporterRelation: boolean,
  minorRelationFSupporterName: string,
  minorSupporterDateofBirth: string,
  minorSupporterNationality: string

}
export interface LinkData {
  id: string;
  customerId: string;
  applicationId: string;
  purposeOfAccount: string;
  otherDescription: string;
  accountNature: string;
  accountType: string;
  productId: number;
  currencyId: string;
  description: string;
  city: string;
  cityCode: string;
  areaId: number;
  areaName: string;
  branchCode: string;
  branchName: string;
  branchId: number;
  cityId: number;
}
export interface AddressInfo {
  mailingResidenceAddressLine1: string;
  mailingResidenceAddressLine2: string;
  mailingResidenceCity: string;
  mailingResidenceCountry: string;
  mailingResidencePostCode: string;
  mailingResidenceState: string;
  permanentResidenceAddressLine1: string;
  permanentResidenceAddressLine2: string;
  permanentResidenceCity: string;
  permanentResidenceCountry: string;
  permanentResidencePostCode: string;
  permanentResidenceState: string;
}
export interface Geo {
  geoplugin_request: string;
  geoplugin_status: number;
  geoplugin_delay: string;
  geoplugin_credit: string;
  geoplugin_city: string;
  geoplugin_region: string;
  geoplugin_regionCode: string;
  geoplugin_regionName: string;
  geoplugin_areaCode: string;
  geoplugin_dmaCode: string;
  geoplugin_countryCode: string;
  geoplugin_countryName: string;
  geoplugin_inEU: number;
  geoplugin_euVATrate: boolean;
  geoplugin_continentCode: string;
  geoplugin_continentName: string;
  geoplugin_latitude: string;
  geoplugin_longitude: string;
  geoplugin_locationAccuracyRadius: string;
  geoplugin_timezone: string;
  geoplugin_currencyCode: string;
  geoplugin_currencySymbol: string;
  geoplugin_currencySymbol_UTF8: string;
  geoplugin_currencyConverter: number;
}
export interface CurrencyRate {
  ccY_Sale: string;
  ();
  ccY_Buy: string;
  rateBuy: string;
  rateSale: string;
  entryDate: string;
  rateForDisplay: string;
}

export interface DocObject {
  Docname: string;
}

export interface RequestDocObject {
  DocName: string;
  DocType: string;
  TempDocId: string;
}
export interface W8Form {
  id: number;
  fatcaId: number;
  userId: string;
  name: string;
  dob: Date;
  countryOfCitizenship: string;
  permanentresidenceAddressLine1: string;
  permanentresidenceAddressLine2: string;
  permanentCountry: string;
  permanentState: string;
  permanentCity: string;
  permanentPostalCode: string;
  mailingPermanentresidenceAddressLine1: string;
  mailingPermanentresidenceAddressLine2: string;
  mailingCountry: string;
  mailingState: string;
  mailingCity: string;
  mailingPostalCode: string;
  taxPayerType: string;
  taxNumber: string;
  article: string;
  taxTreatyClaim: boolean;
  beneficalOwnerCountry: string;
  treatyPercentageRate: string;
  typeOfIncome: string;
  explanation: string;
  isActive: boolean;
  createdBy: string;
  createdOn: Date;
  referenceSec: string;
  tinNotRequired: number;
}
export interface Balances {
  accountId: Number;
  productId: Number;
  acctClass: string;
  balance: string;
  accountTitle: string;
  currency: string;
  accountNumber: string;
  productName: string;
  isNpcProduct: boolean;
  iban: string;
  colorClass: string;
  isChequeBookProduct: boolean;
  isCdcAccount: boolean;
  cdcApplied: boolean;
  isDebitBlocked: boolean;
  isCharity: boolean;
  accountNature: string;
}

export interface registrationObjectFBL {
  companyId: number;
  firstName: string;
  middleName: string;
  familyName: string;
  countryID: string;
  mobileNumber: string;
  dOB: string;
  gender: string;
  nationality: string;
  dOE: string;
  documentCode: string;
  documentNumber: string;
  ResidenceCountry: string;
  issuer: string;
  optionalData1: string;
  optionalData2: string;
  mrtdraw: string;
  frontCardImage: string;
  backCardImage: string;
  personFaceImage: string;
  fireBaseToken: string;
  platform: string;
  email: string;
  password: string;
  confirmPassword: string;
  FullName: string;
  issuedate: string;
  IsSpent: boolean;
  UniqueId: string;
  IsUSMobileNo: boolean;
  IsLifeTimeCnic: boolean;
  videocall: string;
  IsForeignTaxPayed: boolean;
  Referredby: string;
  IsReferred: boolean;
  Latitude: string;
  Longitude: string;
  cardtype: string;
  dOI: string;
  selfieimage: string;
  selfietransactionid: string;
  facialtransactionid: string;
  mobileNo: string;

  CountryName: string;
  City: string;
  State: string;
  Postal: string;
  CountryCode: string;
  PluginDelay: string;

  RegionCode: string;
  Region: string;
  ContinentName: string;
  RegionName: string;
  Ip: string;
  accountType: string;

  TimeZone: string;
  journeyId: string;
  fatherName: string;
  IsFatherName:boolean;
}
export interface RegistrationModel {
  companyId: number;
  firstName: string;
  middleName: string;
  familyName: string;
  motherName: string;
  countryID: string;
  mobileNumber: string;
  dOB: string;
  gender: string;
  nationality: string;
  dOE: string;
  documentCode: string;
  documentNumber: string;
  residenceCountry: string;
  issuer: string;
  optionalData1: string;
  optionalData2: string;
  mrtdraw: string;
  frontCardImage: string;
  backCardImage: string;
  personFaceImage: string;
  fireBaseToken: string;
  platform: string;
  email: string;
  password: string;
  confirmPassword: string;
  fullName: string;
  issuedate: string;
  FatherName: string;
  CityId: number;
  BranchId: number;
  IsSpent: boolean;
  UniqueId: string;
  IsUSMobileNo: boolean;
  IsLifeTimeCnic: boolean;
  videocall: string;
  IsForeignTaxPayed: boolean;
  Referredby: string;
  IsReferred: boolean;
  Latitude: string;
  Longitude: string;
  cardtype: string;
  IsFatherName: boolean;
  dOI: string;
  selfieimage: string;
  selfietransactionid: string;
  facialtransactionid: string;
}

export interface RegisterIDMinor {
  firstName: string,
  selfieimage: string,
  middleName: string,
  lastName: string,
  dOB: string,
  gender: string,
  idtype: string,
  documentNumber: string,
  issuedate: string,
  fullname: string,
  familyName: string,
  mobileNumber: string,
  nationality: string,
  accountType: string,
  countryname: string,
  documentcode: string,
}

export interface RegistrationSecModel {
  companyId: number;
  firstName: string;
  middleName: string;
  familyName: string;
  countryID: string;
  mobileNumber: string;
  dOB: string;
  gender: string;
  nationality: string;
  dOE: string;
  documentCode: string;
  documentNumber: string;
  residenceCountry: string;
  issuer: string;
  optionalData1: string;
  optionalData2: string;
  mrtdraw: string;
  frontCardImage: string;
  backCardImage: string;
  personFaceImage: string;
  fireBaseToken: string;
  platform: string;
  email: string;
  fullName: string;
  issuedate: string;
  FatherName: string;
  CityId: number;
  BranchId: number;
  IsSpent: boolean;
  UniqueId: string;
  IsUSMobileNo: boolean;
  IsLifeTimeCnic: boolean;
  videocall: string;
  IsForeignTaxPayed: boolean;
  PrimaryUserId: string;
}

export interface SecIdCardExpireModel {
  PrimaryUserId: string;
  CompanyId: number;
  issuedate: string;
  FirstName: string;
  MiddleName: string;
  FamilyName: string;
  CountryID: string;
  DOB: string;
  Gender: string;
  Nationality: string;
  DOE: string;
  IsLifeTimeCNIC: boolean;
  DocumentCode: string;
  DocumentNumber: string;
  Issuer: string;
  OptionalData1: string;
  OptionalData2: string;
  MrtDraw: string;
  FrontCardImage: string;
  BackCardImage: string;
  PersonFaceImage: string;
  Type: string;
  FullName: string;
  fireBaseToken: string;
}

export interface IdCardExpireModel {
  documentCode: string;
  frontCardImage: string;
  backCardImage: string;
  firstName: string;
  documentNumber: string;
  middleName: string;
  familyName: string;
  gender: string;
  dOB: string;
  dOE: string;
  issuer: string;
  issuedate: string;
  fullName: string;
  mrtDraw: string;
  optionalData1: string;
  optionalData2: string;
  fireBaseToken: string;
  personFaceImage: string;
  companyId: number;
  countryID: string;
  nationality: string;
  type: string;
  IsLifeTimeCnic: boolean;
  cardtype: string;
  selfieimage: string;
  selfietransactionid: string;
  facialtransactionid: string;
  journeyId: string;
  fatherName: string;
  accountType: string;
  IsFatherName: boolean;

}

export interface HashModel {
  IncomingObject: any;
  GeneratedHash: string;
}

export interface PageCounterModel {
  UniqueId: string;
  IpAddress: string;
  Browser: string;
  PageName: string;
  DeviceType: string;
  Country: string;
}

export interface LoginModel {
  Email: string;
  Password: string;
  UniqueId: string;
  CaptchaId: string;
  UserEnteredCaptchaCode: string;
}

export interface LoginModelV5 {
  Email: string;
  Password: string;
  UniqueId: string;
  RecaptchaToken: string;
  Ip: string;
}

export interface OnBoardingAccount {
  accountNumber: string;
  accountStatus: string;
  applicationId: string;
  callStatus: string;
  currency: string;
  debitBlockStatus: boolean;
  iban: string;
  productId: number;
  isAsaanRemittance: boolean;
  pdfname: string;
  producthint: string;
  digitalAccount: boolean;
  disclaimercheck: boolean;
  minorcomplete:boolean;
}
export interface Detail {
  coRaddfld: string;
  cob: string;
  countryOfBirth: string;
  dob: Date;
  emailId: string;
  emailStatus: boolean;
  fatherName: string;
  feedbackResponse: boolean;
  firstBio: boolean;
  firstName: string;
  fullname: string;
  gender: string;
  idIssuer: string;
  isExisting: boolean;
  isForeignTaxPayed: boolean;
  IsIdCardExpire: boolean;
  isUSMobileNo: boolean;
  lastName: string;
  middleName: string;
  mobileNumber: string;
  mobileStatus: boolean;
  nationality: string;
  newDevice: boolean;
  occupation: string;
  onBoardingAccount: OnBoardingAccount;
  PassportNationality: string;
  PersonFaceImage: string;
  residenceCountry: string;
  tokenTimeOut: number;
  userId: string;
  videocall: string;
  faceImage: string;
  PassportExpiry: boolean;
  IsSpentDays: boolean;
  idNumber: string;
  accountType: string;

}

export interface DetailSec {
  coRaddfld: string;
  cob: string;
  dob: Date;
  emailId: string;
  emailStatus: boolean;
  fatherName: string;
  feedbackResponse: boolean;
  firstBio: boolean;
  firstName: string;
  fullname: string;
  gender: string;
  idIssuer: string;
  isExisting: boolean;
  isForeignTaxPayed: boolean;
  IsIdCardExpire: boolean;
  isUSMobileNo: boolean;
  lastName: string;
  middleName: string;
  mobileNumber: string;
  mobileStatus: boolean;
  nationality: string;
  newDevice: boolean;
  occupation: string;
  onBoardingAccount: OnBoardingAccount;
  PassportNationality: string;
  PersonFaceImage: string;
  residenceCountry: string;
  tokenTimeOut: number;
  userId: string;
  videocall: string;
  faceImage: string;
  PassportExpiry: boolean;
  IsSpentDays: boolean;
}

export interface LinkAccountRequestModel {
  uniqueId: string;
  applicationId: string;
  basicAccount: string;
  accountNature: string;
  ListOfLinkAccount: LinkAccountObject[];
}

export interface LinkAccountObject {
  currency: string;
  accountType: string;
  accountNature: string;
}

export interface OBJ {
  variablee: number;
}

export interface data {
  dob: string;
  fullname: string;
  gender: string;
  idIssuer: string;
  mobileNumber: string;
  nationality: string;
  userId: string;
  idNumber: string;
}

export class UserDetails {
  accountNature: string;
  accountType: string;
  addDocumentDetail: null;
  atM_CardType: null;
  atm: false;
  chequeBook: false;
  chequeBookLeave: 0;
  cityOfBirth: string;
  cityOfResidence: string;
  cnicType: string;
  consent: true;
  countryOfResidence: string;
  crsconfirm: true;
  dob: string;
  documentNo: string;
  doe: string;
  doi: string;
  eStatement: boolean;
  email: string;
  expectedMonthlyTrnOver: string;
  fatcaForm: string;
  fatcaconsent: boolean;
  fatherName: string;
  firstName: string;
  fullName: string;
  gender: string;
  isFatherName: boolean;
  isLifeTimeCnic: boolean;
  isUSPerson: string;
  lastName: string;
  middleName: string;
  mobileNumber: string;
  monthlyIncome: string;
  motherName: string;
  nameOfRemitter: string;
  occupation: string;
  otherNameOfRemitter: string;
  postCodeResidence: string;
  productId: 0;
  purposeOfAccount: string;
  relationshipwithRemitter: string;
  res_Add_PO_Box: string;
  res_Attrny_US: string;
  res_Recv_Funds: string;
  res_USBirthPlace: string;
  res_USResident_Citizen: string;
  res_US_Res_Add: string;
  res_US_Tel_Num: string;
  residenceContactNo: string;
  residenceHouseNo: string;
  residenceRoad: string;
  residencestreet: string;
  residentPakistani: boolean;
  sms: boolean;
  termsandcondition: boolean;
  w_8_BEN_Form: string;
  w_9_Form: string;
  zakatdeduction: boolean;

}
@Injectable({
  providedIn: "root",
})
export class AuthService {
  public platform: string = "w";
  public GetVersionUrl: string = "AppVersion/currentVersionPE";
  public GetGeoInfoUrl: string = "http://www.geoplugin.net/json.gp?ip={0}";
public getCompleteMinor: string = "Video/GetMinorComplete"
  public RegisterURL: string = "Auth/Registerv3";
  public RegisterSecURL: string = "Auth/RegisterSecv3";
  public LoginURL: string = "Auth/LoginV5";
  public ResendEmailOTPURL: string = "Auth/ResendOnboardingEmailOTP";
  public ResendEmailOTPSecURL: string = "Auth/ResendOnboardingEmailOTPSec";
  public ChangeOnboardingEmail: string = "Auth/ChangeEmailV1";
  public ChangeOnboardingEmailSecURL: string = "Auth/ChangeEmailSecV1";
  public ChangeOnboardingMobile: string = "Auth/ChangeMobile";
  public VerifyOnboardingEmail: string = "Auth/verifyEmailOTP";
  public VerifyOnboardingEmailSecURL: string = "Auth/verifyEmailOTPSec";
  public VerifyOnboardingMobile: string = "Auth/verifyMobileOTP";
  public SendOnboardingMobileOTPURL: string = "Auth/SendOnboardingMobileOTP";
  public SendOTPByTypeURL: string = "Auth/sendotptoken";
  public VerifyOTPByTypeURL: string = "Auth/verifyOtpByType";
  public SaveTempImageUrl: string = "Auth/savetempImage";
  public SaveTempDocUrl: string = "Auth/savetempdoc";
  public IdCardSaveURL: string = "IdCard/SaveV3";
  public IdCardGuardianSaveURL: string = "IdCard/SaveGuardianV3";

  public RegisterMinorURL: string = "Auth/RegisterMinor";
  public UpdateRegisterMinorURL: string = "Auth/UpdateRegisterMinor";


  public IdCardManualSaveURL: string = "IdCard/SaveV3Manual";


  public IdCardGuardianManualSaveURL: string = "IdCard/SaveV3GuardianManual";

  public SecIdCardSaveURL: string = "IdCard/SaveV3Sec";
  public Savepagecounterurl: string = "Auth/SavePageCount";
  public residenceCountry: string;
  public accessToken: string;
  public checkemailURL: string = "Auth/checkEmail";
  public BalanceInqURL: string = "Auth/AccountBalanceInquiryV3Web";
  public verifyTokenURL: string = "Auth/verifytoken";
  public LinkAccountURL: string = "EForm/SaveOtherAccountRequest";
  public LinkAccountrequestURL: string = "EForm/SaveOtherAccountRequestV2";
  public CheckOtherAccountReqURL: string = "Web/CheckOtherAccountReq";
  public FetchBrokerListURL: string = "Web/FetchBrokerList";
  public ConversionURL: string = "EForm/SaveConversionForm";
  public SaveNPCURL: string = "EForm/SaveNPCForm";

  public GetAddressURL: string = "AddFldResp/GetInfoForFatca";

  ipaddressurl: string = "";
  public GetExchangeRateURL: string = "ExchangeRate/GetExchangeRate";
  public GetAllExchangeRateURL: string = "ExchangeRate/GetAllExchangeRate";

  public SendBackOfficeEmailURL: string = "Auth/SendBackOfficeEmail";

  public SendForgotPOTPURL: string = "Auth/SendForgotPasswordOTP";
  public VerifyForgotPasswordOTPURL: string = "Auth/VerifyForgotPasswordOTP";
  public ChangePasswordURL: string = "Auth/ChangePassword";
  private sendOTPURL: string = "Auth/verifyMobileOTP";
  private AcuantOperationURL: string = "Auth/AcuantOperation";
  private checkMobileNumberURL: string = "Auth/checkmobile";
  private RecheckMobileNumberURL: string = "Auth/recheckmobile";

  public RegisterfblURL: string = "Auth/RegisterFBLV2";
  public RegisterfblmanualURL: string = "Auth/RegisterFBLManual";

  public IduploadreciptURL: string = "IdCard/UploadRecieptV1";
  private VerifyChangeMobileURL: string = "Settings/VerifyChangeMobileOTP";
  private MobileNumberURL: string = "Settings/changeMobile";
  private LinkAccountDataURL: string = "LinkAccount/GetSavedData";
  private AdditionalDataURL: string = "AddFldResp/GetSavedData";
  private AdditionalDataMinorURL: string = "AddFldResp/GetSavedDataForMinor";
  private IDDataMinorURL: string = "IdCard/SavedDataMinorId";


  private AdditionalDataV1URL: string = "AddFldResp/GetAdditionalFieldsIcome";
  private AdditionalDataV2URL: string = "AddFldResp/GetAdditionalFieldsIcomeV1";

  private GetFatcaURL: string = "FatcaCrs/GetFatcaAnswer";
  private GetW8URL: string = "FatcaCrs/GetW8";
  private GetW9URL: string = "FatcaCrs/GetW9";
  private GetCrsListURL: string = "FatcaCrs/GetCRS";
  private GetDataForBioURL: string = "LinkAccount/GetDateForBio";
  private SaveDataForBioURL: string = "LinkAccount/UpdateBioStep";

  private GetJourneyIDWiseURL = "Auth/GetJourneyIDWise";
  private GetJourneyIDWiseAuthorizeURL = "Auth/GetJourneyIDWiseAuthorize";

  public CRSData: CRSData[] = [];
  public AddData1: AddData1 = {
    expectedMonthlyTrnOver: "",
    monthlyIncome: "",
    otherNationality: "",
    CountryList: ""
  };
  public W9Data: W9Data = {
    otherExplanation: "",
    id: 0,
    fatcaId: 0,
    userId: "",
    name: "",
    entityName: "",
    taxClassification: "",
    isLimited: false,
    addressInUsLine1: "",
    addressInUsLine2: "",
    state: "",
    city: "",
    postCode: "",
    accountNumber: "",
    payeeCode: "",
    fatcaReportingCode: "",
    isAnyOtherRequester: false,
    requesterName: "",
    requesterAddressLine1: "",
    requesterAddressLine2: "",
    requesterState: "",
    requesterCity: "",
    requesterPostCode: "",
    typeOfTaxPayer: "",
    taxNumber: "",
    isReportedByIRS: "",
    isActive: false,
    createdBy: "",
    createdOn: new Date(),
  };
  public AddData: AddData = {
    cardTypeReason: "",
    maritalStatus: "",
    relationshipwithRemitter: "",
    nameOfRemitter: "",
    otherNationality: "",
    id: "",
    applicationId: "",
    customerId: "",
    placeOfBirth: "",
    countryOfBirth: "",
    fatherName: "",
    isFatherName: false,
    motherName: "",
    cardType: "",
    atm: false,
    sms: false,
    smSPlan: "",
    eStatement: false,
    statementFrequency: "",
    email: "",
    chequeBook: false,
    chequeBookLeave: 0,
    zakatDeduction: false,
    occupation: "",
    residenceHouseNo: "",
    residenceBuilding: "",
    residenceStreet: "",
    residenceRoad: "",
    residenceStateId: 0,
    residenceCityId: 0,
    postCodeResidence: "",
    residenceContact: "",
    countryOfResidence: "",
    mailingHouseNo: "",
    mailingBuilding: "",
    mailingStreet: "",
    mailingRoad: "",
    mailingStateId: 0,
    mailingCityId: 0,
    postCodeOfMailAdd: "",
    mailingContact: "",
    countryOfMailAdd: "",
    minorFatherName: "",
    minorMotherName: "",
    minorCitybirth: "",
    minorDualNationality: false,
    minorDualNationalityCountry: "",
    minorTaxResidency: false,
    minorTaxResidencyCountry: "",
    minorFSupporterName: "",
    minorFSupporterRelation: false,
    minorRelationFSupporterName: "",
    minorSupporterDateofBirth: "",
    minorSupporterNationality: "",






  };
  public GeoData: Geo = {
    geoplugin_areaCode: "",
    geoplugin_city: "",
    geoplugin_continentCode: "",
    geoplugin_continentName: "",
    geoplugin_countryCode: "",
    geoplugin_countryName: "",
    geoplugin_credit: "",
    geoplugin_currencyCode: "",
    geoplugin_currencyConverter: 0,
    geoplugin_currencySymbol: "",
    geoplugin_currencySymbol_UTF8: "",
    geoplugin_delay: "",
    geoplugin_dmaCode: "",
    geoplugin_euVATrate: false,
    geoplugin_inEU: 0,
    geoplugin_latitude: "",
    geoplugin_locationAccuracyRadius: "",
    geoplugin_longitude: "",
    geoplugin_region: "",
    geoplugin_regionCode: "",
    geoplugin_regionName: "",
    geoplugin_request: "",
    geoplugin_status: 0,
    geoplugin_timezone: "",
  };
  public LinkData: LinkData = {
    id: "",
    otherDescription: "",
    customerId: "",
    applicationId: "",
    purposeOfAccount: "",
    accountNature: "",
    accountType: "",
    productId: 0,
    currencyId: "",
    description: "",
    city: "",
    cityCode: "",
    areaId: 0,
    areaName: "",
    branchCode: "",
    branchName: "",
    cityId: 0,
    branchId: 0,
  };

  public CurrencyRate: CurrencyRate[] = [];
  public AddressInfo: AddressInfo = {
    mailingResidenceAddressLine1: "",
    mailingResidenceAddressLine2: "",
    mailingResidenceCity: "",
    mailingResidenceCountry: "",
    mailingResidencePostCode: "",
    mailingResidenceState: "",
    permanentResidenceAddressLine1: "",
    permanentResidenceAddressLine2: "",
    permanentResidenceCity: "",
    permanentResidenceCountry: "",
    permanentResidencePostCode: "",
    permanentResidenceState: "",
  };
  public AllBalance: Balances[] = [];

  public datadetail: data;
  public productID: string;

  public obj: OBJ = {
    variablee: 0,
  };
  public data: Detail = {
    faceImage: "",
    newDevice: false,
    countryOfBirth: "",
    onBoardingAccount: {

      iban: "",
      accountStatus: "",
      accountNumber: "",
      productId: 36,
      applicationId: "",
      currency: "",
      callStatus: "",
      debitBlockStatus: false,
      isAsaanRemittance: false,
      pdfname: "",
      producthint: "",
      digitalAccount: false,
      disclaimercheck: false,
      minorcomplete:false



    },
    accountType: "",
    idNumber: "",
    fullname: "",
    emailId: "",
    mobileNumber: "",
    mobileStatus: false,
    emailStatus: false,
    isExisting: false,
    userId: "",
    nationality: "",
    firstName: "",
    residenceCountry: "",
    lastName: "",
    gender: "",
    dob: new Date(),
    idIssuer: "",
    tokenTimeOut: null,
    PassportNationality: "",
    IsIdCardExpire: false,
    PersonFaceImage: "",
    middleName: "",
    coRaddfld: "",
    cob: "",
    fatherName: "",
    feedbackResponse: false,
    firstBio: false,
    isForeignTaxPayed: false,
    isUSMobileNo: false,
    occupation: "",
    videocall: "",
    PassportExpiry: false,
    IsSpentDays: false,
  };

  public dataSec: DetailSec = {
    faceImage: "",
    newDevice: false,
    onBoardingAccount: {
      iban: "",
      accountStatus: "",
      accountNumber: "",
      productId: 36,
      applicationId: "",
      currency: "",
      callStatus: "",
      debitBlockStatus: false,
      isAsaanRemittance: false,
      pdfname: "",
      producthint: "",
      digitalAccount: false,
      disclaimercheck: false,
      minorcomplete:false
    },
    fullname: "",
    emailId: "",
    mobileNumber: "",
    mobileStatus: false,
    emailStatus: false,
    isExisting: false,
    userId: "",
    nationality: "",
    firstName: "",
    residenceCountry: "",
    lastName: "",
    gender: "",
    dob: new Date(),
    idIssuer: "",
    tokenTimeOut: null,
    PassportNationality: "",
    IsIdCardExpire: false,
    PersonFaceImage: "",
    middleName: "",
    coRaddfld: "",
    cob: "",
    fatherName: "",
    feedbackResponse: false,
    firstBio: false,
    isForeignTaxPayed: false,
    isUSMobileNo: false,
    occupation: "",
    videocall: "",
    PassportExpiry: false,
    IsSpentDays: false,
  };

  public LinkAccountRequestObj: LinkAccountRequestModel = {
    applicationId: "",
    ListOfLinkAccount: [],
    basicAccount: "",
    uniqueId: "",
    accountNature: "",
  };

  public docobject: DocObject;

  public RequestDocObject: RequestDocObject;
  public FatcaAnswer: FatcaAnswer = {
    consent: false,
    crsconfirm: false,
    fatcaconsent: false,
    question1: "",
    question2: "",
    question3: "",
    question4: "",
    question5: "",
    residentPakistani: false,
    termsandcondition: false,
  };
  public registrationObject: RegistrationModel = {
    selfieimage: "",
    backCardImage: "",
    familyName: "",
    fireBaseToken: "",
    firstName: "",
    frontCardImage: "",
    fullName: "",
    motherName: "",
    dOB: "",
    dOE: "",
    documentCode: "",
    documentNumber: "",
    email: "",
    residenceCountry: "",
    issuer: "",
    optionalData1: "",
    optionalData2: "",
    middleName: "",
    mobileNumber: "",
    mrtdraw: "",
    nationality: "",
    companyId: 1,
    confirmPassword: "",
    countryID: "",
    password: "",
    personFaceImage: "",
    platform: "",
    gender: "",
    issuedate: "",
    FatherName: "",
    CityId: null,
    BranchId: null,
    IsSpent: true,
    UniqueId: "",
    IsUSMobileNo: false,
    IsLifeTimeCnic: false,
    videocall: "",
    IsForeignTaxPayed: false,
    IsReferred: false,
    Referredby: "",
    Latitude: "",
    Longitude: "",
    cardtype: "",
    IsFatherName: false,
    dOI: "",
    selfietransactionid: "",
    facialtransactionid: "",
  };



  public MinorIddetailsObject: RegisterIDMinor = {
    firstName: "",
    selfieimage: "",
    middleName: "",
    lastName: "",
    dOB: "",
    gender: "",
    idtype: "",
    documentNumber: "",
    issuedate: "",
    fullname: "",
    familyName: "",
    mobileNumber: "",
    nationality: "",
    accountType: "",
    countryname: "",
    documentcode: "",
  };


  public registrationSecObject: RegistrationSecModel = {
    backCardImage: "",
    familyName: "",
    fireBaseToken: "",
    firstName: "",
    frontCardImage: "",
    fullName: "",
    dOB: "",
    dOE: "",
    documentCode: "",
    documentNumber: "",
    email: "",
    residenceCountry: "",
    issuer: "",
    optionalData1: "",
    optionalData2: "",
    middleName: "",
    mobileNumber: "",
    mrtdraw: "",
    nationality: "",
    companyId: 1,
    countryID: "",
    personFaceImage: "",
    platform: "",
    gender: "",
    issuedate: "",
    FatherName: "",
    CityId: null,
    BranchId: null,
    IsSpent: true,
    UniqueId: "",
    IsUSMobileNo: false,
    IsLifeTimeCnic: false,
    videocall: "",
    IsForeignTaxPayed: false,
    PrimaryUserId: "",
  };

  public registrationfblObject: registrationObjectFBL = {
    selfieimage: "",
    backCardImage: "",
    familyName: "",
    fireBaseToken: "",
    firstName: "",
    frontCardImage: "",
    FullName: "",
    dOB: "",
    dOE: "",
    documentCode: "",
    documentNumber: "",
    email: "",
    ResidenceCountry: "",
    issuer: "",
    optionalData1: "",
    optionalData2: "",
    middleName: "",
    mobileNumber: "",
    mrtdraw: "",
    nationality: "",
    companyId: 1,
    confirmPassword: "",
    countryID: "",
    password: "",
    personFaceImage: "",
    platform: "",
    gender: "",
    issuedate: "",
    IsSpent: true,
    UniqueId: "",
    IsUSMobileNo: false,
    IsLifeTimeCnic: false,
    videocall: "",
    IsForeignTaxPayed: false,
    IsReferred: false,
    Referredby: "",
    Latitude: "",
    Longitude: "",
    cardtype: "",
    dOI: "",
    selfietransactionid: "",
    facialtransactionid: "",
    mobileNo: "",
    CountryName: "",
    City: "",
    State: "",
    Postal: "",
    CountryCode: "",
    PluginDelay: "",
    RegionCode: "",
    Region: "",
    ContinentName: "",
    RegionName: "",
    TimeZone: "",
    Ip: "",
    accountType: "",
    journeyId: "",
    fatherName: "",
    IsFatherName:false
  };

  public SaveCounterobject: PageCounterModel = {
    Browser: "",
    DeviceType: "",
    IpAddress: "",
    PageName: "",
    UniqueId: "",
    Country: "",
  };

  public IdCardObject: IdCardExpireModel = {
    backCardImage: "",
    companyId: 1,
    countryID: "",
    dOB: "",
    dOE: "",
    documentCode: "",
    documentNumber: "",
    familyName: "",
    fireBaseToken: "",
    firstName: "",
    frontCardImage: "",
    fullName: "",
    gender: "",
    issuedate: "",
    issuer: "",
    middleName: "",
    mrtDraw: "",
    nationality: "",
    optionalData1: "",
    optionalData2: "",
    personFaceImage: "",
    type: "",
    IsLifeTimeCnic: false,
    cardtype: "",
    selfieimage: "",
    selfietransactionid: "",
    facialtransactionid: "",
    journeyId: "",
    fatherName: "",
    accountType: "",
    IsFatherName:false
  };

  public MinorObject: IdCardExpireModel = {
    backCardImage: "",
    companyId: 1,
    countryID: "",
    dOB: "",
    dOE: "",
    documentCode: "",
    documentNumber: "",
    familyName: "",
    fireBaseToken: "",
    firstName: "",
    frontCardImage: "",
    fullName: "",
    gender: "",
    issuedate: "",
    issuer: "",
    middleName: "",
    mrtDraw: "",
    nationality: "",
    optionalData1: "",
    optionalData2: "",
    personFaceImage: "",
    type: "",
    IsLifeTimeCnic: false,
    cardtype: "",
    selfieimage: "",
    selfietransactionid: "",
    facialtransactionid: "",
    journeyId: "",
    fatherName: "",
    accountType:"",
    IsFatherName:false

  };

  public SecIdCardObject: SecIdCardExpireModel = {
    PrimaryUserId: "",
    CompanyId: 1,
    CountryID: "",
    DOB: "",
    DOE: "",
    DocumentCode: "",
    DocumentNumber: "",
    FamilyName: "",
    fireBaseToken: "",
    FirstName: "",
    FrontCardImage: "",
    BackCardImage: " ",
    FullName: "",
    Gender: "",
    issuedate: "",
    Issuer: "",
    MiddleName: "",
    MrtDraw: "",
    Nationality: "",
    OptionalData1: "",
    OptionalData2: "",
    PersonFaceImage: "",
    Type: "",
    IsLifeTimeCNIC: false,
  };
  public loginobject: LoginModel = {
    Email: "",
    Password: "",
    UniqueId: "",
    CaptchaId: "",
    UserEnteredCaptchaCode: "",
  };

  public loginobjectV5: LoginModelV5 = {
    Email: "",
    Password: "",
    UniqueId: "",
    RecaptchaToken: "",
    Ip: "",
  };
  public W8Form: W8Form = {
    referenceSec: "",
    tinNotRequired: 0,
    id: 0,
    fatcaId: 0,
    userId: "",
    name: "",
    dob: new Date(),
    article: "",
    countryOfCitizenship: "",
    permanentresidenceAddressLine1: "",
    permanentresidenceAddressLine2: "",
    permanentCountry: "",
    permanentState: "",
    permanentCity: "",
    permanentPostalCode: "",
    mailingPermanentresidenceAddressLine1: "",
    mailingPermanentresidenceAddressLine2: "",
    mailingCountry: "",
    mailingState: "",
    mailingCity: "",
    mailingPostalCode: "",
    taxPayerType: "",
    taxNumber: "",
    taxTreatyClaim: false,
    beneficalOwnerCountry: "",
    treatyPercentageRate: "",
    typeOfIncome: "",
    explanation: "",
    isActive: false,
    createdBy: "",
    createdOn: new Date(),
  };
  public selectedCountry: Country = {
    mask: "",
    mobileLength: 0,
    isActive: false,
    isBlink: false,
    isColorTest: false,
    isFeatured: false,
    isMobile: false,
    isStayAllowed: false,
    isoCode: "",
    isoCode3: "",
    countryName: "",
    createdDate: new Date(),
    crossAllowed: false,
    featureOrder: 0,
    flagClass: "",
    foriegnIssuerAllowed: false,
    foriegnNationalityAllowed: false,
    primaryIssuerAllowed: false,
    primaryNationalityAllowed: false,
    idLength: 9,
    mobileCode: "",
    mobileOperators: [],
    nationality: "",
    twoParts: false,
    mobileMaxLength: 0,
    blinkCode: 0,
  };

  public AllUserDetials: UserDetails = {
    accountNature: "",
    accountType: "",
    addDocumentDetail: null,
    atM_CardType: null,
    atm: false,
    chequeBook: false,
    chequeBookLeave: 0,
    cityOfBirth: "",
    cityOfResidence: "",
    cnicType: "",
    consent: true,
    countryOfResidence: "",
    crsconfirm: true,
    dob: "",
    documentNo: "",
    doe: "",
    doi: "",
    eStatement: false,
    email: "",
    expectedMonthlyTrnOver: "",
    fatcaForm: "",
    fatcaconsent: false,
    fatherName: "",
    firstName: "",
    fullName: "",
    gender: "",
    isFatherName: false,
    isLifeTimeCnic: false,
    isUSPerson: "",
    lastName: "",
    middleName: "",
    mobileNumber: "",
    monthlyIncome: "",
    motherName: "",
    nameOfRemitter: "",
    occupation: "",
    otherNameOfRemitter: "",
    postCodeResidence: "",
    productId: 0,
    purposeOfAccount: "",
    relationshipwithRemitter: "",
    res_Add_PO_Box: "",
    res_Attrny_US: "",
    res_Recv_Funds: "",
    res_USBirthPlace: "",
    res_USResident_Citizen: "",
    res_US_Res_Add: "",
    res_US_Tel_Num: "",
    residenceContactNo: "",
    residenceHouseNo: "",
    residenceRoad: "",
    residencestreet: "",
    residentPakistani: false,
    sms: false,
    termsandcondition: false,
    w_8_BEN_Form: "",
    w_9_Form: "",
    zakatdeduction: false,

  };

  constructor(
    private http: HttpServiceService,
    private config: ConfigService,
    private storagemap: StorageMap
  ) { }
  CleanregistrationfblObject() {
    (this.registrationfblObject.selfieimage = ""),
      (this.registrationfblObject.backCardImage = "");
    this.registrationfblObject.familyName = "";
    this.registrationfblObject.fireBaseToken = "";
    this.registrationfblObject.firstName = "";
    this.registrationfblObject.frontCardImage = "";
    this.registrationfblObject.FullName = "";
    this.registrationfblObject.dOB = "";
    this.registrationfblObject.dOE = "";
    this.registrationfblObject.documentCode = "";
    this.registrationfblObject.documentNumber = "";
    this.registrationfblObject.email = "";
    this.registrationfblObject.ResidenceCountry = "";
    this.registrationfblObject.issuer = "";
    this.registrationfblObject.optionalData1 = "";
    this.registrationfblObject.optionalData2 = "";
    this.registrationfblObject.middleName = "";
    this.registrationfblObject.mobileNumber = "";
    this.registrationfblObject.mrtdraw = "";
    this.registrationfblObject.nationality = "";
    (this.registrationfblObject.companyId = 1),
      (this.registrationfblObject.confirmPassword = "");
    this.registrationfblObject.countryID = "";
    this.registrationfblObject.password = "";
    this.registrationfblObject.personFaceImage = "";
    this.registrationfblObject.platform = "";
    this.registrationfblObject.gender = "";
    this.registrationfblObject.issuedate = "";
    this.registrationfblObject.IsSpent = true;
    this.registrationfblObject.UniqueId = "";
    this.registrationfblObject.IsUSMobileNo = false;
    this.registrationfblObject.IsLifeTimeCnic = false;
    this.registrationfblObject.videocall = "";
    this.registrationfblObject.IsForeignTaxPayed = false;
    this.registrationfblObject.IsReferred = false;
    this.registrationfblObject.Referredby = "";
    this.registrationfblObject.Latitude = "";
    this.registrationfblObject.Longitude = "";
    this.registrationfblObject.cardtype = "";
    this.registrationfblObject.dOI = "";
    this.registrationfblObject.selfietransactionid = "";
    this.registrationfblObject.facialtransactionid = "";
    this.registrationfblObject.mobileNo = "";
  }
  public ClearFatca() {
    this.FatcaAnswer = {
      consent: false,
      crsconfirm: false,
      fatcaconsent: false,
      question1: "",
      question2: "",
      question3: "",
      question4: "",
      question5: "",
      residentPakistani: false,
      termsandcondition: false,
    };
  }
  public ClearW8() {
    this.W8Form = {
      referenceSec: "",
      tinNotRequired: 0,
      id: 0,
      article: "",
      fatcaId: 0,
      userId: "",
      name: "",
      dob: new Date(),
      countryOfCitizenship: "",
      permanentresidenceAddressLine1: "",
      permanentresidenceAddressLine2: "",
      permanentCountry: "",
      permanentState: "",
      permanentCity: "",
      permanentPostalCode: "",
      mailingPermanentresidenceAddressLine1: "",
      mailingPermanentresidenceAddressLine2: "",
      mailingCountry: "",
      mailingState: "",
      mailingCity: "",
      mailingPostalCode: "",
      taxPayerType: "",
      taxNumber: "",
      taxTreatyClaim: false,
      beneficalOwnerCountry: "",
      treatyPercentageRate: "",
      typeOfIncome: "",
      explanation: "",
      isActive: false,
      createdBy: "",
      createdOn: new Date(),
    };
  }
  Get(key: string): Promise<any> {
    return new Promise((resolve) => {

      this.storagemap.get(key).subscribe(
        (value) => {
          console.log('keyhai', key);

          console.log('yevalue', value);
          if (value) {
            resolve(value);
          } else {
            resolve("");
          }
        },
        (error) => {
          resolve("");
        }
      );
    });
  }

  delete(Key: string): Promise<any> {
    return new Promise((resolve) => {
      this.storagemap.delete(Key);
    });
  }

  public ClearDetail() {
    this.ClearW9();
    this.ClearW8();
    this.ClearFatca();
    this.data = {
      faceImage: "",
      newDevice: false,
      idNumber: "",
      onBoardingAccount: {
        iban: "",
        digitalAccount: false,
        accountStatus: "",
        accountNumber: "",
        productId: 36,
        applicationId: "",
        currency: "",
        callStatus: "",
        debitBlockStatus: false,
        isAsaanRemittance: false,
        pdfname: "",
        producthint: "",
        disclaimercheck: false,
        minorcomplete:false
      }, accountType: "",
      fullname: "",
      emailId: "",
      mobileNumber: "",
      mobileStatus: false,
      emailStatus: false,
      isExisting: false,
      userId: "",
      countryOfBirth: "",
      nationality: "",
      firstName: "",
      residenceCountry: "",
      lastName: "",
      gender: "",
      dob: new Date(),
      idIssuer: "",
      tokenTimeOut: null,
      PassportNationality: "",
      IsIdCardExpire: false,
      PersonFaceImage: "",
      middleName: "",
      coRaddfld: "",
      cob: "",
      fatherName: "",
      feedbackResponse: false,
      firstBio: false,
      isForeignTaxPayed: false,
      isUSMobileNo: false,
      occupation: "",
      videocall: "",
      PassportExpiry: false,
      IsSpentDays: false,
    };
    this.LinkClear();
    this.ClearAddData();
    this.ClearAddDatav1();
  }
  public ClearAddDatav1() {
    this.AddData1 = {
      expectedMonthlyTrnOver: "",
      monthlyIncome: "",
      otherNationality: "",
      CountryList: ""
    };
  }
  public LinkClear() {
    this.LinkData = {
      otherDescription: "",
      id: "",
      customerId: "",
      applicationId: "",
      purposeOfAccount: "",
      accountNature: "",
      accountType: "",
      productId: 0,
      currencyId: "",
      description: "",
      city: "",
      cityCode: "",
      areaId: 0,
      areaName: "",
      branchCode: "",
      branchName: "",
      cityId: 0,
      branchId: 0,
    };
  }
  public ClearAddData() {
    this.AddData = {
      cardTypeReason: "",
      relationshipwithRemitter: "",
      nameOfRemitter: "",
      maritalStatus: "",
      otherNationality: "",
      id: "",
      applicationId: "",
      customerId: "",
      placeOfBirth: "",
      countryOfBirth: "",
      fatherName: "",
      isFatherName: false,
      motherName: "",
      cardType: "",
      atm: false,
      sms: false,
      smSPlan: "",
      eStatement: false,
      statementFrequency: "",
      email: "",
      chequeBook: false,
      chequeBookLeave: 0,
      zakatDeduction: false,
      occupation: "",
      residenceHouseNo: "",
      residenceBuilding: "",
      residenceStreet: "",
      residenceRoad: "",
      residenceStateId: 0,
      residenceCityId: 0,
      postCodeResidence: "",
      residenceContact: "",
      countryOfResidence: "",
      mailingHouseNo: "",
      mailingBuilding: "",
      mailingStreet: "",
      mailingRoad: "",
      mailingStateId: 0,
      mailingCityId: 0,
      postCodeOfMailAdd: "",
      mailingContact: "",
      countryOfMailAdd: "",

      minorFatherName: "",
      minorMotherName: "",
      minorCitybirth: "",
      minorDualNationality: false,
      minorDualNationalityCountry: "",
      minorTaxResidency: false,
      minorTaxResidencyCountry: "",
      minorFSupporterName: "",
      minorFSupporterRelation: false,
      minorRelationFSupporterName: "",
      minorSupporterDateofBirth: "",
      minorSupporterNationality: ""
    };
  }
  public ClearW9() {
    this.W9Data = {
      otherExplanation: "",
      id: 0,
      fatcaId: 0,
      userId: "",
      name: "",
      entityName: "",
      taxClassification: "",
      isLimited: false,
      addressInUsLine1: "",
      addressInUsLine2: "",
      state: "",
      city: "",
      postCode: "",
      accountNumber: "",
      payeeCode: "",
      fatcaReportingCode: "",
      isAnyOtherRequester: false,
      requesterName: "",
      requesterAddressLine1: "",
      requesterAddressLine2: "",
      requesterState: "",
      requesterCity: "",
      requesterPostCode: "",
      typeOfTaxPayer: "",
      taxNumber: "",
      isReportedByIRS: "",
      isActive: false,
      createdBy: "",
      createdOn: new Date(),
    };
  }
  public SaveTempImage(token, image) {
    debugger;
    if (Array.isArray(image)) {
      return new Promise((resolve, reject) => {
        this.http
          .postToCloseApi(
            this.config.server + this.SaveTempImageUrl,
            { Image: image[1], Type: image[2] },
            token
          )
          .subscribe(
            (data: any) => {
              if (data.response) {
                if (data.response.code) {
                  if (data.response.code == 1) {
                  }
                }
              }
              resolve(data);
            },
            (Error) => {
              resolve(Error);
            }
          );
      });
    } else {
      return new Promise((resolve, reject) => {
        this.http
          .postToCloseApi(
            this.config.server + this.SaveTempImageUrl,
            { Image: image, Type: "JPG" },
            token
          )
          .subscribe(
            (data: any) => {
              if (data.response) {
                if (data.response.code) {
                  if (data.response.code == 1) {
                  }
                }
              }
              resolve(data);
            },
            (Error) => {
              resolve(Error);
            }
          );
      });
    }
  }

  public saveTempimage2(token, image, type) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SaveTempImageUrl,
          { Image: image, Type: type },
          token
        )
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SaveTempDocs(token, image) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SaveTempDocUrl,
          { DocBased64: image },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GEttep() {
    return new Promise((resolve, reject) => {
      this.http.getFromOpenApi("assets/Steps.json", "").subscribe(
        (data: any) => {
          resolve(data);
        },
        (Error) => {
          resolve(Error);
        }
      );
    });
  }

  public GetAPIUrl() {
    return new Promise((resolve, reject) => {
      this.http.getFromOpenApi("assets/APIURL.json", "").subscribe(
        (data: any) => {
          resolve(data);
        },
        (Error) => {
          resolve(Error);
        }
      );
    });
  }

  public GetGeoData() {
    return new Promise((resolve, reject) => {
      this.http.getFromOpenApiV1(this.GetGeoInfoUrl, "").subscribe(
        (data: any) => {
          resolve(data);
        },
        (Error) => {
          resolve(Error);
        }
      );
    });
  }

  public GetDashboardText() {
    return new Promise((resolve, reject) => {
      this.http.getFromOpenApi("assets/dashboardText.json", "").subscribe(
        (data: any) => {
          resolve(data);
        },
        (Error) => {
          resolve(Error);
        }
      );
    });
  }

  public ChangeEmailOnboarding(emailId, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.ChangeOnboardingEmail,
          { EmailId: emailId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public ChangeEmailOnboardingSec(object, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.ChangeOnboardingEmailSecURL,
          { EmailId: object.emailid, SecUserId: object.SecUserId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public GetAddressInfo(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.GetAddressURL, {}, token)
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public SavePageCounter(object) {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.Savepagecounterurl, object)
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                  this.data = data.response.content;
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public FetchBrokerListMethod(object) {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.FetchBrokerListURL, {
          UniqueId: object,
        })
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
              resolve(data);
            }
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public CheckEmail(emailId, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.checkemailURL,
          { EmailId: emailId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public CheckOtherAccountMethod(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.CheckOtherAccountReqURL,
          { userId: this.data.userId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
              resolve(data);
            }
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public ChangeMobileOnboarding(mobile, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.ChangeOnboardingMobile,
          { mobileNumber: mobile },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public getminorcomp(token, body) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.getCompleteMinor,
          body,
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public BalanceInquiry(uniquId, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.BalanceInqURL,
          { UniqueId: uniquId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public LinkAccount(
    baiscAccount,
    ApplicationId,
    uniquId,
    Currency,
    AccounType,
    token
  ) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.LinkAccountURL,
          {
            UniqueId: uniquId,
            ApplicationId: ApplicationId,
            Currency: Currency,
            BasicAccount: baiscAccount,
            AccountType: AccounType,
          },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SaveOtherLinkAccount(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.LinkAccountrequestURL,
          this.LinkAccountRequestObj,
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public ConversionForm(
    ApplicationId,
    uniquId,
    DebitCurrency,
    DebitAccount,
    CreditCurrency,
    CreditAccount,
    ExRate,
    Amount,
    AmountInWords,
    token
  ) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.ConversionURL,
          {
            UniqueId: uniquId,
            ApplicationId: ApplicationId,
            DebitCurrency: DebitCurrency,
            DebitAccount: DebitAccount,
            CreditCurrency: CreditCurrency,
            CreditAccount: CreditAccount,
            ExRate: ExRate,
            AmountInWord: AmountInWords,
            Amount: Amount,
          },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SaveNPCFORM(
    ApplicationId,
    uniquId,
    DebitCurrency,
    DebitAccount,
    ExRate,
    Amount,
    Tenure,
    SelectedCertificate,
    numberOfCertificate,
    totlaamount,
    token
  ) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SaveNPCURL,
          {
            TotalAmount: totlaamount,
            UniqueId: uniquId,
            ApplicationId: ApplicationId,
            DebitCurrency: DebitCurrency,
            DebitAccount: DebitAccount,
            ExRate: ExRate,
            Amount: Amount,
            NumberOfCertificates: numberOfCertificate,
            Tenure: Tenure,
            CertificateCurrency: SelectedCertificate,
          },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public VerifyEmailOnboarding(otp, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.VerifyOnboardingEmail,
          { otpCode: otp },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public VerifyEmailOnboardingSec(object, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.VerifyOnboardingEmailSecURL,
          { otpCode: object.code, SecUserId: object.SecUserId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GetExchangeRate(token, uniqueId) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetExchangeRateURL,
          { UniqueId: uniqueId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                  this.CurrencyRate = data.response.content.pkrList;
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GetAllRate(token, uniqueId) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetAllExchangeRateURL,
          { UniqueId: uniqueId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public VerifyMobileOnboarding(otp, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.VerifyOnboardingMobile,
          { otpCode: otp },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SendOnboardingMobileOTP(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SendOnboardingMobileOTPURL,
          {},
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public ResendMobileOTP(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SendOnboardingMobileOTPURL,
          {},
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public ResendEmailOTP(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.ResendEmailOTPURL, {}, token)
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public ResendEmailOTPSec(SecUserId, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.ResendEmailOTPSecURL,
          { SecUserId: SecUserId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public clearRegistrationObject() {
    this.registrationObject = {
      backCardImage: "",
      familyName: "",
      fireBaseToken: "",
      firstName: "",
      frontCardImage: "",
      fullName: "",
      motherName: "",
      dOB: "",
      dOE: "",
      documentCode: "",
      documentNumber: "",
      email: "",
      residenceCountry: "",
      issuer: "",
      optionalData1: "",
      optionalData2: "",
      middleName: "",
      mobileNumber: "",
      mrtdraw: "",
      nationality: "",
      companyId: 1,
      confirmPassword: "",
      countryID: "",
      password: "",
      personFaceImage: "",
      platform: "",
      gender: "",
      issuedate: "",
      FatherName: "",
      CityId: null,
      BranchId: null,
      IsSpent: true,
      UniqueId: "",
      IsUSMobileNo: null,
      IsLifeTimeCnic: null,
      videocall: "",
      IsForeignTaxPayed: false,
      IsReferred: false,
      Referredby: "",
      Latitude: "",
      Longitude: "",
      cardtype: "",
      IsFatherName: false,
      dOI: "",
      selfieimage: "",
      selfietransactionid: "",
      facialtransactionid: "",
    };
  }

  public clearRegistrationSecObject() {
    this.registrationSecObject = {
      backCardImage: "",
      familyName: "",
      fireBaseToken: "",
      firstName: "",
      frontCardImage: "",
      fullName: "",
      dOB: "",
      dOE: "",
      documentCode: "",
      documentNumber: "",
      email: "",
      residenceCountry: "",
      issuer: "",
      optionalData1: "",
      optionalData2: "",
      middleName: "",
      mobileNumber: "",
      mrtdraw: "",
      nationality: "",
      companyId: 1,
      countryID: "",
      personFaceImage: "",
      platform: "",
      gender: "",
      issuedate: "",
      FatherName: "",
      CityId: null,
      BranchId: null,
      IsSpent: true,
      UniqueId: "",
      IsUSMobileNo: null,
      IsLifeTimeCnic: null,
      videocall: "",
      IsForeignTaxPayed: false,
      PrimaryUserId: "",
    };
  }

  public GetVersion() {
    return new Promise((resolve, reject) => {
      this.http
        .getFromOpenApi(
          this.config.server,
          this.GetVersionUrl + "?Platform=" + "A"
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public Login(object) {
    return new Promise((resolve, reject) => {
      let hashobject: HashModel = {
        IncomingObject: object,
        GeneratedHash: "",
      };
      this.http
        .postToOpenApi(this.config.server + this.LoginURL, object)
        .subscribe(
          (data: any) => {
            if (data?.response?.code == 1) {
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public Register(isManual: ConstrainBoolean) {
    debugger;
    console.log("Register OBJECT", this.registrationfblObject);
    return new Promise((resolve, reject) => {
      debugger;
      this.http
        .postToOpenApi(
          this.config.server +
          (isManual == true
            ? this.RegisterfblmanualURL
            : this.RegisterfblURL),
          this.registrationfblObject
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                  this.data = data.response.content;
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public RegisterSec() {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(
          this.config.server + this.RegisterSecURL,
          this.registrationSecObject
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                  this.data = data.response.content;
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SendBackOfficeEmailFunction(token, UniqueId) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SendBackOfficeEmailURL,
          { UniqueId: UniqueId },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public RegisterMinor() {
    return new Promise((resolve, reject) => {
      debugger
      this.http
        .postToOpenApi(
          this.config.server +
          this.RegisterMinorURL,
          this.MinorIddetailsObject
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
            console.log('RegisterMinor', data)
          },
          (Error) => {
            resolve(Error);
            console.log('RegisterMinorError', Error)

          }
        );
    });
  }


  public UpdateRegisterMinor(token) {
    return new Promise((resolve, reject) => {
      debugger
      this.http
        .postToCloseApi(
          this.config.server +
          this.UpdateRegisterMinorURL,
          this.MinorIddetailsObject, token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
            console.log('UpdateRegisterMinor', data)
          },
          (Error) => {
            resolve(Error);
            console.log('UpdateRegisterMinorError', Error)

          }
        );
    });
  }



  public SaveIdCard(token, object, isManual) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server +
          (isManual ? this.IdCardManualSaveURL : this.IdCardSaveURL),
          object,
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public RegisterGuardian(token, object, isManual) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server +
          (isManual ? this.IdCardManualSaveURL : this.IdCardSaveURL),
          object,
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SaveSecIdCard(token, object) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SecIdCardSaveURL,
          object,
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public SendOTPByType(token, type) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SendOTPByTypeURL,
          { Type: type },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public SendForgotPasswordOTP(IdNumber, uniqueId) {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.SendForgotPOTPURL, {
          idNumber: IdNumber,
          uniqueId: uniqueId,
        })
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public VerifyForgotPasswordOTP(IdNumber, uniqueId, otp) {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.VerifyForgotPasswordOTPURL, {
          IdNumber: IdNumber,
          UniqueId: uniqueId,
          OTPCODE: otp,
        })
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public ChangePassword(IdNumber, uniqueId, otp, Password, ConfirmPassword) {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.ChangePasswordURL, {
          IdNumber: IdNumber,
          UniqueId: uniqueId,
          OTPCODE: otp,
          Password: Password,
          ConfirmPassword: ConfirmPassword,
        })
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public VerifyOTPByType(token, type, otp) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.VerifyOTPByTypeURL,
          { Type: type, OTPCode: otp },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  RegisterSession(token) {
    this.accessToken = token;
  }

  public checkMobileNumber(mobileNumber, captchatoken, data) {
    console.log(data, "data");
    return new Promise((resolve, reject) => {
      debugger;
      this.http
        .postToOpenApi(this.config.server + this.checkMobileNumberURL, {
          mobileNumber: mobileNumber,
          uniqueId: data,
          fireBase: "",
          RecaptchaToken: captchatoken,
        })
        .subscribe(
          (data) => {
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public RecheckMobileNumber(mobileNumber, data) {
    console.log(data, "data");
    return new Promise((resolve, reject) => {
      debugger;
      this.http
        .postToOpenApi(this.config.server + this.RecheckMobileNumberURL, {
          mobileNumber: mobileNumber,
          uniqueId: data,
          fireBase: "",
        })
        .subscribe(
          (data) => {
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public checkMobileset(mobileNumber, IsUsNumber, token) {
    return new Promise((resolve, reject) => {
      debugger;
      this.http
        .postToCloseApi(
          this.config.server + this.MobileNumberURL,
          { mobileNumber: mobileNumber, IsUsNumber: IsUsNumber },
          token
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public VerifyOTPMobile(
    mobileNumber,
    otpCode,
    data,
    log,
    lat,
    RecaptchaToken,
    Ip,
    CountryName,
    City,
    CountryCode,
    PluginDelay,
    RegionCode,
    Region,
    ContinentName,
    RegionName,
    TimeZone
  ) {
    console.log(data, "data");
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.sendOTPURL, {
          mobileNumber: mobileNumber,
          RecaptchaToken: RecaptchaToken,
          Ip: Ip,
          otpCode: otpCode,
          uniqueId: data,
          Longitude: log,
          Latitude: lat,
          fireBase: "",
          CountryName,
          City,
          CountryCode,
          PluginDelay,
          RegionCode,
          Region,
          ContinentName,
          RegionName,
          TimeZone,
        })
        .subscribe(
          (data: any) => {
            console.log(data, "VerifyOTPMobile");
            if (data.response.code) {
              if (data.response.code == 1) {
                if (data.response.content) {
                  this.datadetail = data.response.content;
                  console.log(this.datadetail);
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public VerifyChangeMobile(Number, Code, isUsNumberbol, token) {
    {
      return new Promise((resolve, reject) => {
        debugger;
        this.http
          .postToCloseApi(
            this.config.server + this.VerifyChangeMobileURL,
            { mobileNumber: Number, otpCode: Code, isUsNumber: isUsNumberbol },
            token
          )
          .subscribe(
            (data: any) => {
              if (data.response.code) {
                if (data.response.code == 1) {
                  if (data.response.content) {
                    this.datadetail = data.response.content;
                    console.log(this.datadetail);
                  }
                }
              }
              resolve(data);
            },
            (Error) => {
              resolve(Error);
            }
          );
      });
    }
  }

  public AcuantOperation(personFaceImage, ImageSelfie, Idnumber, uniqueId) {
    let dto = {
      ImageFace: personFaceImage,
      ImageSelfie: ImageSelfie,
      Idnumber: Idnumber,
      uniqueId: uniqueId,
    };
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(this.config.server + this.AcuantOperationURL, dto)
        .subscribe(
          (data: any) => {
            if (data.response.code) {
              if (data.response.code == 1) {
                if (data.response.content) {
                  let AcuantOperation = data.response.content;
                  console.log(AcuantOperation, "AcuantOperation");
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public getIPAddress() {
    return new Promise((resolve, reject) => {
      this.http
        .getOpenApi("https://api.ipify.org/?format=json")
        .subscribe((data: any) => {
          console.log(data.ip, "CLientIP");
        });
    });
  }
  public Saveuploadrecipt(token, Reciept, Type) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.IduploadreciptURL,
          { Reciept: Reciept, Type: Type },
          token
        )
        .subscribe(
          (data: any) => {
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public verifyToken(token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.verifyTokenURL, {}, token)
        .subscribe(
          (data: any) => {
            console.log(data);
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                  console.log(data, "verifyToken");
                  this.data = data.response.content.l;

                  console.log(data, "bd wala verifyToken");

                  this.dataSec = data.response.content.lSec;
                  console.log(this.data, "verifyToken");
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GetLinkData(token, applicationId) {
    this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.LinkAccountDataURL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GetAdditionalData(token, applicationId) {
    this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.AdditionalDataURL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  //  this.config.server + this.AdditionalDataMinorURL,
  //token

  public GetAdditionalDataForMinor(token, body) {
    this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.AdditionalDataMinorURL, body,
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }



  public GetIdDataForMinor(token, body) {
    //sthis.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.IDDataMinorURL, body,
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }


  public GetAdditionalDataV1(token, applicationId) {
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.AdditionalDataV2URL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public GetFatca(token, applicationId) {
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetFatcaURL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public GetW8(token, applicationId) {
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetW8URL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public GetW9(token, applicationId) {
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetW9URL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public GetCRSList(token, applicationId) {
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetCrsListURL,
          { ApplicationId: applicationId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }

  public GetDataForBio(token) {
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(this.config.server + this.GetDataForBioURL, {}, token)
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public SaveBioData(token, data) {
    console.log(data);
    // this.LinkClear();
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.SaveDataForBioURL,
          data,
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data);

            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public async GetFromJson() {
    return new Promise((resolve, reject) => {
      this.http.getFromOpenApi("assets/APIURL.json", "").subscribe(
        (data: any) => {
          //console.log(data);

          resolve(data);
        },
        (Error) => {
          resolve(Error);
        }
      );
    });
  }


  public getIdWise(journeyId) {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(
          this.config.server + this.GetJourneyIDWiseURL,
          { journeyId: journeyId },

        )
        .subscribe(
          (data: any) => {
            console.log(data, "getIdWise")
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
  public getIdWiseAuth(journeyId, token) {
    return new Promise((resolve, reject) => {
      this.http
        .postToCloseApi(
          this.config.server + this.GetJourneyIDWiseAuthorizeURL,
          { journeyId: journeyId },
          token
        )
        .subscribe(
          (data: any) => {
            console.log(data, "getIdWise")
            if (data.response) {
              if (data.response.code) {
                if (data.response.code == 1) {
                }
              }
            }
            resolve(data);
          },
          (Error) => {
            resolve(Error);
          }
        );
    });
  }
}
